import {ListReducerBuilder} from '../../../../utils/reducers';
import {IDENTIFIER} from '../actions';

export default {
    designPartners: ListReducerBuilder.build(IDENTIFIER, false)
};